import { useParams } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { PipelinesWorkspace } from './PipelinesPage';

/** ADMIN-01 — one pipeline, beside the list (Pipelines A). `new` opens an empty one. */
export function PipelineEditorPage(): ReactNode {
  const { pipelineId } = useParams({ from: '/app-layout/admin/pipelines/$pipelineId' });
  return <PipelinesWorkspace selectedId={pipelineId} />;
}
